import { z } from 'zod';
import { uuidSchema } from './validation.js';
const trimmed = (max) => z.string().trim().min(1).max(max);
const optionalMetadata = z.string().trim().max(40).nullable().optional();
export const warehousePositionStatusSchema = z.enum(['active', 'archived']);
export const warehousePositionSkuPolicySchema = z.enum(['single', 'mixed']);
export const warehousePositionAssignmentKindSchema = z.enum(['preferred', 'overflow']);
export const listWarehousePositionsSchema = z.object({
    locationId: uuidSchema,
    zoneId: uuidSchema.optional(),
    status: z.enum(['active', 'archived', 'all']).default('active'),
    codeQuery: z.string().trim().max(80).optional(),
    skuId: uuidSchema.optional(),
    stockOwnerOrganizationId: uuidSchema.optional(),
    offset: z.number().int().nonnegative().default(0),
    limit: z.number().int().min(1).max(200).default(50),
});
export const warehousePositionQrSchema = z.object({
    token: z.string().regex(/^THP:\/\/POS:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/, 'Invalid warehouse position QR token'),
});
export const createWarehousePositionSchema = z.object({
    locationId: uuidSchema,
    zoneId: uuidSchema.nullable().optional(),
    code: trimmed(80),
    bay: optionalMetadata,
    shelf: optionalMetadata,
    slot: optionalMetadata,
    skuPolicy: warehousePositionSkuPolicySchema.default('single'),
    walkOrder: z.number().int().nonnegative().nullable().optional(),
    notes: z.string().trim().max(2000).nullable().optional(),
});
export const updateWarehousePositionSchema = createWarehousePositionSchema
    .omit({ locationId: true })
    .partial()
    .extend({ id: uuidSchema });
export const warehousePositionIdSchema = z.object({ id: uuidSchema });
export const warehousePositionAssignmentSchema = z.object({
    skuId: uuidSchema,
    stockOwnerOrganizationId: uuidSchema,
    kind: warehousePositionAssignmentKindSchema,
});
export const replaceWarehousePositionAssignmentsSchema = z.object({
    positionId: uuidSchema,
    assignments: z.array(warehousePositionAssignmentSchema).max(500),
}).superRefine((value, ctx) => {
    const seen = new Set();
    value.assignments.forEach((assignment, index) => {
        const key = `${assignment.stockOwnerOrganizationId}:${assignment.skuId}`;
        if (seen.has(key)) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                path: ['assignments', index],
                message: 'A SKU can be assigned to a position only once',
            });
        }
        seen.add(key);
    });
});
export const searchAssignableWarehouseSkusSchema = z.object({
    locationId: uuidSchema,
    query: z.string().trim().max(120).default(''),
    stockOwnerOrganizationId: uuidSchema.optional(),
    limit: z.number().int().min(1).max(100).default(30),
});
